export class Mov {
  public static calc(str: number, dex: number, siz: number) {
    if (str < siz && dex < siz) {
      return 7;
    } else if ((str >= siz && dex < siz) || (str < siz && dex >= siz) || (str === siz && dex === siz)) {
      return 8;
    } else {
      return 9;
    }
  }
}
